export default __webpack_public_path__ + "static/media/play-icon-new.e30c4739.svg";